// ✅ US Market Contact - Thin Wrapper (DRY principle)
import ContactPage from '../contact';
import SEOHead from '../../components/SEOHead';

export default function USContactPage() {
  return (
    <>
      <SEOHead
        title='Contact | US Businesses | LBVisible'
        description='Get in touch with LBVisible for custom website development, SEO, and digital marketing solutions for US businesses.'
        canonicalUrl='/us/contact'
        lang='en'
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/contact' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/contact' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/kontaktai' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/contact' },
        ]}
      />

      {/* Reuse the main Contact component - single source of truth for design */}
      <ContactPage />
    </>
  );
}
